import { FormRow, ObjectDataRecord } from '@types'

export const mapFormKeysToCoreKeys = (
  formValues: ObjectDataRecord,
  fields: FormRow[]
): ObjectDataRecord => {
  const fieldsByCode: Record<string, FormRow> = {}

  for (const field of fields) {
    fieldsByCode[field.code] = field
  }

  const coreRecord: ObjectDataRecord = {}

  for (const [key, value] of Object.entries(formValues)) {
    const formField = fieldsByCode[key]
    const coreKey = formField?.value || key
    coreRecord[coreKey] = value
  }

  return coreRecord
}
